module.exports = __webpack_public_path__ + "img/home-certification-01.f34c9efb.png";